import { Select, SelectField, type SelectFieldProps, type SelectProps } from '@nvision/ui';

import { useCarrierServices } from '../../hooks';
import type { CarrierService, CarrierServiceFilters } from '../../models';

export interface CarrierServiceFieldProps extends Omit<SelectProps<CarrierService>, 'options'> {
  defaultFilters?: Partial<CarrierServiceFilters & { searchParams: { ids: string[] } }>;
  label?: string;
  errorMessage?: SelectFieldProps<CarrierService>['errorMessage'];
  isInvalid?: boolean;
}

export const CarrierServiceField: React.FC<CarrierServiceFieldProps> = ({
  defaultFilters,
  label,
  ...otherFieldProps
}) => {
  const { data, isLoading, updateFilters } = useCarrierServices(defaultFilters);

  if (label) {
    return (
      <SelectField
        {...otherFieldProps}
        label={label}
        placeholder="Start typing..."
        options={data?.list ?? []}
        onInputChange={(search) => updateFilters({ search: { description: search } })}
        isLoading={isLoading}
      />
    );
  }

  return (
    <Select
      {...otherFieldProps}
      placeholder="Start typing..."
      options={data?.list ?? []}
      onInputChange={(search) => updateFilters({ search: { description: search } })}
      isLoading={isLoading}
    />
  );
};
